import { Component, Vue } from "vue-property-decorator";

@Component
export default class ExamMixin extends Vue {
  public get hasNotPermissionWrite(): boolean {
    return !this.$can(this.MODULE_EXAM_WRITE);
  }
}
